module.exports = __webpack_public_path__ + "static/img/12.0f7d775.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/eng/12.png
// module id = 3UDo
// module chunks = 0